<mad-sidebar-layout
  [sideBarItems]="sideBarItems"
  [content]="content"
  title="Advanced Sidebar Layout With Default Header"
  [actionGroup]="actionGroup"
>
  <ng-template #actionGroup>
    <mad-button-group>
      <mad-outline-button>Test</mad-outline-button>
      <a color="primary" mat-icon-button title="Action 1">
        <mat-icon>exit_to_app</mat-icon>
      </a>
      <a color="primary" mat-icon-button title="Action 2">
        <mat-icon class="material-icons-outlined">help_center</mat-icon>
      </a>
      <a color="primary" mat-icon-button title="Action 3">
        <mat-icon class="material-icons-outlined">payments</mat-icon>
      </a>
    </mad-button-group>
  </ng-template>
  <ng-template #sideBarItems>
    <mad-sidebar>
      <a
        mad-sidebar-item
        routerLink="/full-page-layouts/advanced-sidebar-with-default-header-page-layout/1"
        routerLinkActive="active-sidebar-item"
        >Item 1</a
      >
      <a
        mad-sidebar-item
        routerLink="/full-page-layouts/advanced-sidebar-with-default-header-page-layout/2"
        routerLinkActive="active-sidebar-item"
        >Item 2</a
      >
    </mad-sidebar>
  </ng-template>
  <ng-template #content>
    <router-outlet></router-outlet>
  </ng-template>
</mad-sidebar-layout>
